/**
 * 中文语言包
 */
export default {
  common: {
    tip: '提示',
    ok: '确定',
    cancel: '取消',
    send: '发送',
    confirm: '确认',
    search: '搜索',
    delete: '删除',
    save: '保存',
    submit: '提交',
    loading: '加载中...',
    more: '更多',
    close: '关闭',
    noData: '没有数据',
    verify: '验证',
    me: '我',
    remove: '移除',
    back: '返回',
    resizeWidth: '拖拽调整宽度',
    minimize: '最小化',
    fullscreen: '全屏',
    restore: '恢复',
    uploading: '正在上传...',
    fileFormatError: '文件格式错误，请上传以下格式的文件：{formats}',
    fileSizeExceed: '文件大小不能超过 {size}!',
    reachedBottom: '已滚动到底部'
  },
  login: {
    welcome: '欢迎回来',
    welcomeSubtitle: '登录您的账号，开启聊天之旅',
    userName: '用户名',
    userNamePlaceholder: '用户名/手机号/邮箱',
    password: '密码',
    login: '登录',
    logging: '正在登陆...',
    qrLogin: '扫码登录',
    noAccount: '没有账号? 立即注册',
    forgotPwd: '忘记密码?',
    demoLogin: '演示模式登录',
    autoLogin: '下次自动登录',
    loginSuccess: '登录成功',
    inputUsername: '请输入用户名',
    inputPassword: '请输入密码'
  },
  register: {
    subtitle: '创建您的账户，开启聊天之旅',
    phoneRegister: '手机注册',
    emailRegister: '邮箱注册',
    usernameRegister: '用户名注册',
    phone: '手机号码',
    smsCode: '短信验证码',
    email: '邮箱',
    emailCode: '邮件验证码',
    userName: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    register: '注册并登录',
    hasAccount: '已有账号? 去登录',
    otherMode: '其他注册方式',
    getCode: '获取验证码',
    resendAfter: '{n}秒后重新获取',
    inputPhone: '请输入手机号码',
    phoneFormatError: '手机号格式错误',
    inputEmail: '请输入邮箱',
    emailFormatError: '邮箱格式错误',
    inputCode: '请输入验证码',
    inputUserName: '请输入用户名',
    inputPassword: '请输入密码',
    inputConfirmPassword: '请再次输入密码',
    passwordMismatch: '两次输入密码不一致',
    smsSent: '验证码已发送至您的手机，请注意查收',
    emailSent: '验证码已发送至您的邮箱，请注意查收',
    registerSuccess: '注册成功，欢迎使用{name}！'
  },
  resetPwd: {
    title: '重置密码',
    wizardTitle: '密码重置向导',
    wizardDesc: '只需四步，轻松重置您的密码',
    step1: '选择方式',
    step2: '验证身份',
    step3: '设置密码',
    step4: '完成',
    selectMode: '请选择密码重置方式',
    phoneReset: '手机号重置',
    phoneResetDesc: '通过短信验证码验证身份',
    emailReset: '邮箱重置',
    emailResetDesc: '通过邮箱验证码验证身份',
    cancel: '取消',
    next: '下一步',
    prev: '上一步',
    verify: '验证',
    verifyIdentity: '验证您的身份',
    phone: '手机号码',
    email: '邮箱',
    smsCode: '短信验证码',
    emailCode: '邮箱验证码',
    inputPhone: '请输入您的手机号码',
    inputSmsCode: '请输入短信验证码',
    inputEmail: '请输入您的邮箱地址',
    inputEmailCode: '请输入6位邮箱验证码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    inputNewPassword: '请输入您的新密码',
    inputConfirmPassword: '请再次输入您的新密码',
    reset: '重置',
    getCode: '获取验证码',
    resendAfter: '{n}秒后重发',
    submit: '提交',
    successTitle: '密码重置成功！',
    successDesc: '您已成功重置密码，请使用新密码登录您的账户。',
    redirectIn: '系统将在 {n} 秒后自动跳转到登录页面',
    toLogin: '立即登录',
    cancelConfirm: '确定要取消密码重置吗？',
    inputCorrectPhone: '请输入正确的手机号',
    inputCorrectEmail: '请输入正确的邮箱地址',
    verifyFail: '验证失败,请重新输入验证码',
    passwordMismatch: '两次密码输入不一致',
    resetSuccess: '密码重置成功！'
  },
  setting: {
    title: '设置',
    personalInfo: '个人资料',
    userConfig: '用户设置',
    bindPhone: '绑定手机',
    bindEmail: '绑定邮箱',
    modifyPassword: '修改密码',
    realnameAuth: '实名认证',
    aboutUs: '关于我们',
    language: '语言',
    languageDesc: '切换界面显示语言'
  },
  favorite: {
    title: '我的收藏',
    all: '全部',
    image: '图片',
    file: '文件',
    sticker: '表情',
    video: '视频',
    audio: '语音',
    fromChat: '来自 {name}',
    unfavorite: '取消收藏',
    unfavoriteConfirm: '确认取消收藏该消息?',
    unfavoriteTitle: '取消收藏',
    batchUnfavoriteConfirm: '确认取消收藏选中的 {n} 条消息?',
    selectToUnfavorite: '请先选择要取消收藏的消息',
    selectToForward: '请先选择要转发的消息',
    selectedCount: '已选择 {n} 条'
  },
  bindPhone: {
    successTitle: '手机号绑定成功',
    successDesc: '您的手机号 {phone} 已成功绑定',
    tipTitle: '建议绑定手机号',
    tipDesc: '绑定手机号后，您可以通过手机号快速重置密码，提高账户安全性',
    formTitle: '手机号绑定',
    inputPhone: '请输入手机号码',
    inputCode: '请输入验证码',
    resendAfter: '{n}秒后重新获取',
    bind: '绑定',
    confirmBind: '手机号码绑定后无法更改，是否绑定？',
    bindSuccess: '手机号码绑定成功',
    sendCodeFail: '发送验证码失败',
    inputPhoneError: '请输入手机号码',
    phoneFormatError: '手机号格式错误',
    inputCodeError: '请输入验证码'
  },
  bindEmail: {
    successTitle: '邮箱绑定成功',
    successDesc: '您的邮箱 {email} 已成功绑定',
    tipTitle: '建议绑定邮箱',
    tipDesc: '绑定邮箱后，您可以通过邮箱快速重置密码，提高账户安全性',
    formTitle: '邮箱绑定',
    inputEmail: '请输入邮箱地址',
    inputCode: '请输入验证码',
    resendAfter: '{n}秒后重新获取',
    bind: '绑定',
    confirmBind: '邮箱绑定后无法更改，是否绑定？',
    bindSuccess: '邮箱绑定成功',
    sendCodeFail: '发送验证码失败',
    inputEmailError: '请输入邮箱',
    emailFormatError: '邮箱格式错误',
    inputCodeError: '请输入验证码'
  },
  qrLogin: {
    title: '扫码登录',
    subtitle: '使用手机APP扫描二维码快速登录',
    generating: '正在生成二维码...',
    scanTip: '请使用手机APP扫描二维码',
    expireTip: '二维码将在 {n} 秒后过期',
    scannedTip: '已扫码，请在手机上确认登录',
    loginSuccess: '登录成功!',
    expired: '二维码已过期',
    refresh: '重新生成',
    ensureAppLoggedIn: '请确保手机APP已登录',
    generateFailed: '生成二维码失败'
  },
  personalInfo: {
    changeAvatar: '更换头像',
    noNickname: '未设置昵称',
    basicInfo: '基本信息',
    company: '企业',
    nickname: '昵称',
    inputNickname: '请输入昵称',
    sex: '性别',
    contact: '联系方式',
    phone: '手机号',
    email: '邮箱',
    noBindPhone: '未绑定手机号',
    noBindEmail: '未绑定邮箱',
    goBind: '去绑定',
    signature: '个性签名',
    signaturePlaceholder: '分享你的心情和想法...',
    submit: '提交',
    modifySuccess: '修改成功',
    sexNotSet: '未设置',
    noSignatureTitle: '还没有个性签名',
    noSignatureDesc: '去个人设置中编辑你的个性签名吧',
    online: '在线',
    userOnline: '用户当前在线'
  },
  realnameAuth: {
    successTitle: '实名认证成功',
    successDesc: '您的实名认证已通过审核',
    realName: '真实姓名',
    idCardNumber: '证件号码',
    authTime: '认证时间',
    pendingTitle: '实名认证审核中',
    pendingDesc: '您的实名认证申请正在审核中，请耐心等待',
    resubmit: '重新提交',
    failTitle: '实名认证失败',
    failReason: '失败原因',
    failDesc: '您的实名认证申请未通过审核，请重新提交',
    tipTitle: '实名认证说明',
    tipDesc: '实名认证可以提高账户安全性，请确保上传的身份证照片清晰可见，信息真实有效',
    resubmitTip: '重新提交将覆盖之前的认证信息',
    formTitle: '实名认证',
    inputRealName: '请输入真实姓名',
    inputIdCard: '请输入身份证号码',
    idCardFront: '身份证正面',
    idCardBack: '身份证反面',
    uploadFront: '上传身份证正面',
    uploadBack: '上传身份证反面',
    uploadFrontTip: '请上传清晰的身份证正面照片',
    uploadBackTip: '请上传清晰的身份证反面照片',
    submitAuth: '提交认证',
    submitSuccess: '实名认证申请已提交，请等待审核',
    confirmSubmit: '审核通过后信息将无法修改，是否确认提交？',
    inputRealNameError: '请输入真实姓名',
    nameLengthError: '姓名长度应在2-20个字符之间',
    inputIdCardError: '请输入身份证号码',
    idCardFormatError: '身份证号码格式错误',
    uploadFrontError: '请上传身份证正面照片',
    uploadBackError: '请上传身份证反面照片'
  },
  captcha: {
    codeError: '验证码错误'
  },
  modifyPassword: {
    title: '修改密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    submit: '提交',
    inputPassword: '请输入密码',
    passwordMismatch: '两次密码输入不一致',
    success: '修改成功'
  },
  userConfig: {
    privacy: '隐私设置',
    manualApprove: '加我为好友时需要验证',
    notification: '通知设置',
    audioTip: '新消息提示音'
  },
  aboutUs: {
    appInfo: '应用信息',
    currentVersion: '当前版本',
    latestVersion: '最新版本',
    updateCheck: '更新检查',
    checkUpdate: '检查更新',
    checking: '检查中...',
    updateNow: '立即更新',
    autoUpdate: '自动更新',
    unknown: '未知',
    latestVersionTip: '当前已是最新版本',
    downloadComplete: '更新下载完成，可以立即安装',
    devNoUpdate: '开发模式下无法检查更新，请在正式版本中使用此功能',
    cannotConnect: '无法连接到更新服务器',
    downloading: '正在下载更新...',
    updateFailed: '更新失败，请稍后重试',
    installConfirm: '安装更新后应用将自动重启，是否继续？',
    installConfirmTitle: '确认安装',
    installNow: '立即安装',
    installUpdate: '立即安装并重启',
    installUpdateLabel: '安装更新',
    installing: '正在安装更新，应用将自动重启...',
    updateAvailable: '发现新版本 {version}，是否立即更新？',
    updateCheckFailed: '检查更新失败: {error}',
    downloadUpdateFailed: '下载更新失败: {error}',
    updateFailedWith: '更新失败: {error}',
    installFailed: '安装失败: {error}'
  },
  home: {
    logout: '退出',
    forceLogout: '您已在其他地方登录，将被强制下线',
    forceLogoutTitle: '强制下线通知',
    systemNotify: '系统通知',
    unknownUser: '未知用户',
    unknownGroup: '未知群聊',
    accountBanned: '您的账号已被管理员封禁',
    accountBannedTitle: '账号被封禁',
    accountBannedReason: '您的账号已被管理员封禁,原因:{reason}',
    accountCancelled: '您的账号已注销',
    initFailed: '初始化失败',
    reconnectSuccess: '重新连接成功',
    reconnecting: '连接断开，正在尝试重新连接...',
    pullMsgFailed: '拉取离线消息失败',
    nUnreadTitle: '{n}条未读'
  },
  chat: {
    search: '搜索',
    checkedContactsCount: '已勾选{n}个联系人',
    recentChats: '最近聊天',
    friendsTab: '好友',
    groupsTab: '群聊',
    receivingMsg: '消息接收中...',
    initializing: "正在初始化...",
    loadingChatHistory: "正在加载聊天记录...",
    noMoreHistory: '没有更多历史消息',
    deleteChat: '删除后记录将清空,确认删除与\'{name}\'的聊天 ?',
    deleteChatTitle: '删除会话',
    notInGroup: '您已不在群聊中，无法查看群资料',
    chatPlaceholder: '聊点什么吧~',
    receiptMessage: '【回执消息】',
    receiptMsg: '回执消息',
    groupInfo: '群聊信息',
    groupShort: '群',
    privateShort: '私聊',
    topShort: '顶',
    official: '官方',
    selectedCount: '已选择 {n}/20 条消息',
    maxLimit: '已达上限',
    forwardOneByOne: '逐条转发',
    mergeForward: '合并转发',
    atMe: '有人@我',
    atMeTag: '[有人@我]',
    atAll: '[@全体成员]',
    atHim: '@他',
    allMembers: '全体成员',
    draft: '[草稿]',
    untop: '取消置顶',
    notifyOn: '新消息提醒',
    deleteChatItem: '删除聊天',
    newMessages: '{n}条新消息',
    backToBottom: '回到底部',
    emoji: '表情',
    sendImage: '发送图片',
    sendVideo: '发送视频',
    sendFile: '发送文件',
    sendVoice: '发送语音',
    voiceCall: '语音通话',
    videoCall: '视频通话',
    groupCall: '多人通话',
    chatHistory: '聊天记录',
    viewChatHistory: '查找聊天记录',
    recommendContact: '推荐该联系人',
    searchChatHistory: '搜索聊天记录',
    allTab: '全部',
    atMeTab: '@我',
    textTab: '文字',
    imageTab: '图片',
    stickerTab: '表情',
    fileTab: '文件',
    voiceTab: '语音',
    videoTab: '视频',
    uploadedAt: '上传于',
    locateInChat: '在聊天中定位',
    noSearchResultInHistory: '未搜索到与\'{text}\'相关的内容',
    forwardMsg: '转发消息',
    inputPlaceholder: '请输入消息（按Ctrl+Enter键换行）',
    newMessageCount: '{n}条消息',
    inputRemark: '请输入备注名',
    clickSetRemark: '点击设置备注名',
    copyUserId: '复制用户ID',
    dndOn: '已开启免打扰',
    dndOff: '已关闭免打扰',
    topOn: '已置顶聊天',
    topOff: '已取消置顶',
    opFailed: '操作失败，请重试',
    addBlacklist: '加入黑名单',
    addBlacklistConfirm: '您将不再收到对方的消息,确认将 \'{name}\'加入黑名单吗?',
    addedBlacklist: '已将\'{name}\'加入黑名单',
    removedBlacklist: '已解除\'{name}\'的黑名单',
    clearChatConfirm: '确定要清空与\'{name}\'的所有聊天记录吗？',
    clearChatTitle: '清空聊天记录',
    clearedChat: '您清空了\'{name}\'的聊天记录',
    remarkSuccess: '备注设置成功',
    remarkCleared: '备注已清除',
    dndLabel: '消息免打扰',
    topLabel: '置顶聊天',
    blacklistLabel: '加入黑名单',
    complaintUser: '被骚扰了？投诉该用户',
    copySuccess: '内容\'{content}\'已复制到剪贴板',
    copyFailed: '复制失败，请手动复制',
    recallCall: '重新呼叫',
    sending: '发送中',
    sendFail: '发送失败',
    allRead: '全体已读',
    you: '你',
    other: '对方',
    copy: '复制',
    addToSticker: '添加到表情',
    multiSelect: '多选',
    recall: '撤回',
    recallConfirm: '确认撤回消息?',
    recallTitle: '撤回消息',
    recallMsgSuccess: '消息已撤回',
    forwardSuccess: '转发成功',
    forwardSuccessToChats: '成功转发 {n} 条消息到 {m} 个会话',
    forwardPartialFail: '成功转发 {success}/{total} 条消息，部分消息转发失败',
    mergeForwardSuccessToChats: '成功合并转发 {n} 条消息到 {m} 个会话',
    mergeForwardPartialFail: '成功转发 {success}/{total} 个会话，部分转发失败',
    locateFail: '无法定位原消息',
    quote: '引用',
    forward: '转发',
    favorite: '收藏',
    favoriteSuccess: '收藏成功',
    top: '置顶',
    download: '下载',
    locateQuote: '定位到原消息',
    recallContent: '{name}撤回了一条消息',
    quoteRecalled: '引用内容已撤回',
    maxSelect20: '最多只能选择20条消息',
    maxSelectChats20: '最多只能选择20个会话',
    notFriendCall: '你已不是对方好友,无法呼叫',
    inCall: '您已在通话中',
    copySuccess2: '内容已复制到剪贴板',
    resendNotSupport: '该消息不支持自动重新发送，建议手动重新发送',
    deleteMsgConfirm: '确认删除消息?',
    deleteMsgTitle: '删除消息',
    addStickerSuccess: '已添加到自定义表情',
    selectToDelete: '请先选择要删除的消息',
    batchDeleteConfirm: '确认删除选中的 {n} 条消息?',
    batchDeleteTitle: '批量删除消息',
    deleteSuccess: '删除成功',
    selectToForward: '请先选择要转发的消息',
    forwardTip: '你选择的消息中, 名片消息、通话消息以及未发送成功的消息将不能转发,是否继续?',
    continueSend: '继续发送',
    noForwardMsg: '没有可转发的消息',
    mergeForwardMin2: '合并转发至少需要选择2条消息',
    unsentForwardTip: '你选择的消息中，有 {n} 条未发送成功的消息不能转发，是否继续转发其他消息？',
    groupChatHistory: '群聊\'{name}\'的聊天记录',
    privateChatHistory: '\'{name1}\'和\'{name2}\'的聊天记录',
    read: '已读',
    unread: '未读',
    nRead: '{n}人已读',
    unsupportedType: '[暂不支持该消息类型]',
    previewImage: '[图片]',
    previewVideo: '[视频]',
    previewFile: '[文件]',
    previewVoice: '[语音]',
    previewUserCard: '[个人名片]',
    previewGroupCard: '[群名片]',
    previewSticker: '[动画表情]',
    userCard: '个人名片',
    groupCard: '群名片',
    mergeForwardCount: '[合并转发] 共{n}条消息',
    viewDetail: '查看详情',
    topMessageLabel: '置顶消息: ',
    removeTopConfirm: '将在当前群聊的所有成员中移除此置顶消息,确认移除？',
    removeTopTitle: '移除置顶',
    voiceCallTag: '[语音通话]',
    videoCallTag: '[视频通话]',
    screenshotHideWindow: '截图时隐藏当前窗口',
    screenshotShortcut: '截图(CTRL + ALT + A)',
    readStatus: '消息已读状态',
    readTab: '已读',
    unreadTab: '未读',
    noReadMembers: '暂无已读成员',
    noUnreadMembers: '暂无未读成员',
    cardExpiredWarning: '该名片已过期',
    inputDisabledGroupDissolved: '群聊已解散',
    inputDisabledGroupQuit: '您已不在群聊中',
    inputDisabledGroupBanned: '群聊已被封禁,原因:{reason}',
    inputDisabledGroupBannedWithTime: '群聊已被封禁,原因:{reason},恢复时间: {time}',
    inputDisabledAllMuted: '全员禁言中，只有群主和管理员发言',
    inputDisabledMuted: '您已被群管理员禁言',
    inputDisabledPeerBanned: '对方账号已被封禁,原因:{reason}',
    inputDisabledPeerBannedWithTime: '对方账号已被封禁,原因:{reason},恢复时间: {time}'
  },
  emotion: {
    searchPlaceholder: '输入表情名称搜索',
    searching: '搜索中...',
    noSearchResult: '未找到相关表情',
    searchHint: '请输入表情名称进行搜索',
    noCustomSticker: '暂无自定义表情，点击上方按钮添加',
    loading: '加载中...',
    noSticker: '暂无表情',
    searchEmoji: '搜索表情',
    recentEmoji: '最近使用',
    allEmoji: '全部表情',
    defaultEmoji: '默认表情',
    myEmoji: '我的表情',
    topSuccess: '置顶成功',
    topFail: '置顶失败',
    deleteStickerConfirm: '确定要删除这个自定义表情吗？',
    deleteStickerTitle: '删除表情',
    deleteSuccess: '删除成功',
    addSuccess: '添加成功'
  },
  friend: {
    newFriend: '新的朋友',
    addFriend: '添加好友',
    applyTitle: '申请添加好友',
    applyTip: '提示: 对方开启了好友验证,等待对方同意后才能成为好友',
    defaultRemark: '我是{name}',
    addSuccess: '添加成功，\'{name}\'已成为您的好友',
    applySent: '您向\'{name}\'发起了好友申请',
    searchPlaceholder: 'ID/昵称/手机号/邮箱,最多展示20条',
    noSearchResult: '未搜索到\'{text}\'相关的用户',
    phone: '手机',
    email: '邮箱',
    waitingApprove: '等待对方验证',
    addAsFriend: '加为好友',
    recvRequests: '收到的申请',
    sendRequests: '发起的申请',
    requestAddOther: '请求添加对方为好友',
    requestAddYou: '请求添加您为好友',
    reject: '拒绝',
    approve: '同意',
    recall: '撤回',
    approveSuccess: '{name} 已成为您的好友',
    rejectSuccess: '您拒绝了 {name} 的好友请求',
    recallSuccess: '您撤回了 {name} 的好友请求',
    usernameId: '用户名(ID)',
    cancelled: '已注销',
    nickname: '昵称',
    company: '所在企业',
    remark: '备注名',
    noRemark: '未设置备注名',
    sendMessage: '发消息',
    sendCard: '分享名片',
    deleteFriend: '删除好友',
    deleteFriendConfirm: '确认删除\'{name}\',并清空聊天记录吗?',
    deleteFriendTitle: '删除好友',
    deleteFriendSuccess: '删除好友成功',
    deleteFriendSuccessWithName: '已删除好友 \'{name}\'',
    confirmRemove: '确认解除?',
    sex: '性别',
    signature: '个性签名',
    noSignature: '这个人很懒，什么都没有留下',
    male: '男',
    female: '女',
    modifyRemark: '修改备注',
    inputFriendRemark: '请输入好友备注',
    remarkMax32: '好友备注长度不能大于32',
    sendSuccess: '发送成功',
    online: '在线',
    onlinePc: '电脑设备在线',
    onlineMobile: '移动设备在线',
  },
  group: {
    join: '加入',
    create: '创建群聊',
    createTitle: '创建群聊',
    createSuccess: '创建成功',
    groupInfo: '群聊信息',
    members: '群成员',
    membersCount: '{n}人',
    searchMembers: '搜索群成员',
    invite: '邀请',
    inviteFriend: '邀请好友进群聊',
    inviteTitle: '邀请好友',
    selectMember: '选择成员',
    searchFriends: '搜索好友',
    checkedFriendsCount: '已勾选{n}位好友',
    inviteSuccess: '邀请成功',
    checkedMembersCount: '已勾选{n}位成员',
    maxSelectMembers: '最多选择{n}位成员',
    remove: '移除',
    removeMemberTitle: '选择成员移出群聊',
    mute: '禁言',
    unmute: '解除禁言',
    owner: '群主',
    manager: '管理员',
    groupName: '群名',
    inputGroupName: '请输入群聊名称',
    groupNameMax20: '群聊名称长度不能大于20',
    remark: '备注名',
    myNickname: '我在本群的昵称',
    notice: '群公告',
    noNotice: '群主未设置',
    changeAvatar: '更换头像',
    viewAllMembers: '查看全部成员',
    banned: '已封禁',
    muted: '禁言中',
    cardExpired: '已过期',
    quit: '退出群聊',
    dissolve: '解散群聊',
    sendCard: '分享名片',
    shareGroup: '分享该群聊',
    selectToRemove: '选择成员进行移除',
    selectToMute: '选择成员进行禁言',
    selectToUnmute: '选择成员进行解除禁言',
    dissolveConfirm: '确认要解散\'{name}\'吗?',
    dissolveConfirmTitle: '确认解散?',
    dissolved: '群聊\'{name}\'已解散',
    quitConfirm: '确认退出\'{name}\',并清空聊天记录吗？',
    quitConfirmTitle: '确认退出?',
    quitSuccess: '您已退出\'{name}\'',
    modifySuccess: '修改成功',
    sendSuccess: '发送成功',
    sendMessage: '发送消息',
    joinSuccess: '您加入了群聊\'{name}\'',
    applyJoin: '申请加入',
    viewProfile: '查看资料',
    muteMember: '开启禁言',
    unmuteMember: '取消禁言',
    kickMember: '移出本群',
    addManager: '设为管理员',
    removeManager: '取消管理员',
    muteSuccess: '您禁言了\'{name}\'',
    unmuteSuccess: '您取消了\'{name}\'的禁言',
    kickConfirm: '确定将成员\'{name}\'移出群聊吗？',
    kickConfirmTitle: '确认移出?',
    kickSuccess: '您将\'{name}\'移出了群聊',
    addManagerSuccess: '您将\'{name}\'设置成为了管理员',
    removeManagerSuccess: '您移除了\'{name}\'的管理员身份',
    viewAllMembersCount: '查看全部{n}名成员',
    allMuted: '全员禁言',
    allowMemberInvite: '允许普通成员邀请好友',
    allowMemberShareCard: '允许普通成员分享名片',
    groupNameLabel: '群聊名称',
    clickSetGroupName: '点击设置群聊名称',
    clickSetGroupRemark: '点击设置备注名',
    clickSetNickname: '点击设置昵称',
    clickSetNotice: '点击设置群公告',
    editNotice: '编辑群公告',
    inputNotice: '请输入群公告',
    clearGroupChatConfirm: '确定要清空\'{name}\'的所有聊天记录吗？',
    clearedGroupChat: '您清空了\'{name}\'的聊天记录',
    removedMembers: '您移除了{n}位成员',
    mutedMembers: '您对{n}位成员进行了禁言',
    unmutedMembers: '您解除了{n}位成员的禁言',
    quitConfirmMsg: '退出群聊后将不再接受群里的消息，确认退出吗？',
    complaintGroup: '被骚扰了？举报该群'
  },
  rtc: {
    micOn: '麦克风已打开',
    micOff: '麦克风已关闭',
    speakerOn: '扬声器已打开',
    speakerOff: '扬声器已关闭',
    cameraOn: '摄像头已开启',
    cameraOff: '摄像头已关闭',
    shareScreen: '共享屏幕',
    cancelShare: '取消共享',
    inviteMember: '邀请成员',
    quitCall: '退出通话',
    voiceCall: '语音通话',
    videoCall: '视频通话',
    video: '视频',
    voice: '语音',
    inCall: '通话中',
    calling: '呼叫中',
    waitingAnswer: '等待对方接听...',
    hungUpCallEnd: '您已挂断,通话结束',
    cancelCallEnd: '已取消呼叫,通话结束',
    rejectedByPeer: '对方拒绝了您的通话请求',
    callCancelledByPeer: '对方取消了呼叫',
    peerHangup: '对方已挂断',
    acceptedOnOtherDevice: '已在其他设备接听',
    rejectedOnOtherDevice: '已在其他设备拒绝',
    notAnswered: '您未接听',
    callCancelled: '通话已取消',
    notJoined: '未进入通话',
    quitCallTip: '退出通话',
    deviceNotSupport: '设备不支持通话',
    cameraAccessFailed: '访问摄像头失败',
    rtcInitFailed: '初始化RTC失败，原因可能是: 1.服务器缺少ssl证书 2.您的设备不支持WebRTC',
    openCameraFailed: '打开摄像头失败',
    openMicFailed: '打开麦克风失败',
    unknownUser: '未知用户',
    inviteToGroupCall: '邀请您加入多人通话',
    otherParticipants: '参与通话的还有:',
    accept: '接受',
    reject: '拒绝',
    joinCallConfirm: '是否加入通话?',
    host: '发起人:',
    nInCall: '{n}人正在通话中',
    incoming: '来电中...',
    hangup: '挂断',
    private: {
      acceptTimeout: '对方无应答',
      devNotSupport: '对方设备不支持通话',
    },
    group: {
      acceptTimeout: ' 超时未接听',
      userBusy: ' 正忙',
      devNotSupport: ' 无法进入通话'
    }
  },
  chatRecord: {
    title: '语音录制',
    duration: '时长',
    notStarted: '未开始',
    recording: '正在录音...',
    paused: '已暂停录音',
    ended: '已结束录音',
    startRecord: '开始录音',
    pauseRecord: '暂停录音',
    resumeRecord: '继续录音',
    endRecord: '结束录音',
    playRecord: '播放录音',
    stopPlay: '停止播放',
    restartRecord: '重新录音',
    sendNow: '立即发送'
  },
  complaint: {
    report: '投诉',
    title: '投诉',
    target: '投诉对象',
    reason: '投诉原因',
    images: '图片证据',
    content: '投诉内容',
    inputContent: '请输入投诉内容',
    selectReason: '请选择投诉原因',
    uploadCount: '您上传了{n}',
    maxImages: '最多上传{n}张图片',
    successMsg: '我们已收到您的投诉，工作人员会在3个工作日内核实并处理',
    harassment: '对我造成骚扰',
    fraud: '疑似诈骗',
    badContent: '传播不良内容',
    other: '其他不正规行为'
  },
  http: {
    methodError: 'http请求方式有误',
    serverError: '服务器出了点小差，请稍后再试',
    notSupport: '服务器不支持当前请求所需要的某个功能'
  },
  date: {
    justNow: '刚刚',
    minutesAgo: '{n}分钟前',
    yesterday: '昨天'
  },
  electron: {
    newMessage: '您有新的未读消息',
    showWindow: '显示窗口',
    quit: '退出'
  },
  tip: {
    group: {
      disband: '{0}解散了群聊',
      quit: '{0}退出了群聊',
      remove: '{0}将{1}移出了群聊',
      invite: '{0}邀请{1}加入了群聊',
      joinByCard: '{0}通过{1}分享的名片加入了群聊',
      joinByQr: '{0}通过{1}分享的二维码加入了群聊',
      topMessage: '{0}置顶了一条消息',
      mutedAll: '{0}开启了全员禁言,只有群主和管理员可以发言',
      unmutedAll: '{0}解除了全员禁言',
      memberMuted: '{0}开启了{1}的禁言',
      memberUnmuted: '{0}解除了{1}的禁言',
      addManager: '{0}成为本群管理员',
      removeManager: '{0}被移除管理员身份',
      rtcStart: '{0}发起了通话',
      rtcEnd: '通话结束',
      banned: '群聊因\'\'{0}\'\'被封禁',
      unbanned: '群聊已解封',
      userBanned: '您的账号因\'\'{0}\'\'被封禁'
    },
    openAccountAntiFraud: '温馨提示：{0}是公开演示账号，请提高警惕，谨防诈骗，切勿向陌生账号转账或泄露个人信息',
    friend: {
      becameFriend: '你们已成为好友，现在可以开始聊天了',
      relationRemoved: '你们的好友关系已解除'
    },
    recall: {
      self: '{0}撤回了一条消息',
      byOther: '{0}撤回了{1}的一条消息',
      privateSelf: '你撤回了一条消息',
      privateOther: '对方撤回了一条消息',
      quote: '引用内容已撤回',
      byAdmin: "该消息可能包含违规内容，内容已被屏蔽"
    }
  },
  act: {
    rtc: {
      notConnected: '未接通',
      rejected: '已拒绝',
      cancelled: '已取消',
      duration: '通话时长 {0}'
    }
  },
  merge: {
    title: {
      chatHistory: '聊天记录',
      groupChatHistory: '群聊\'{0}\'的聊天记录',
      privateChatHistory: '\'{0}\'和\'{1}\'的聊天记录'
    }
  }
}
